import { Directive, Input } from '@angular/core';

import type { TemplateTypeToken } from './typed-template.types';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ng-template[typedTemplate]',
})
export class TypedTemplateDirective<TemplateContext> {
  @Input()
  typedTemplate: TemplateTypeToken<TemplateContext>;

  static ngTemplateContextGuard<TemplateContext>(
    _dir: TypedTemplateDirective<TemplateContext>,
    _ctx: unknown,
  ): _ctx is TemplateContext {
    return true;
  }
}
